var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-product-tail"},[_c('p',[_vm._v("\n        Kategoria:\n    ")]),_vm._v(" "),_c('BaseLink',{attrs:{"href":_vm.categoryUrl}},[_vm._v("\n        "+_vm._s(_vm.categoryName)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }